module.exports = __webpack_public_path__ + "img/logo_header.966dce4d.png";